export default __webpack_public_path__ + "static/media/applicant_green.c0d644f1.svg";